import AppStorage from '@Services/AppStorage';

function getZoomForKey() {
  // Always fetch from AppStorage session storage
  const stored = AppStorage.instance.getFromSessionStorage('zoom');
  return typeof stored === 'number' ? stored : 0;
}

function storeZoomForKey(zoomLevel) {
  AppStorage.instance.setToSessionStorage('zoom', zoomLevel);
}

export default {
  getZoomForKey,
  storeZoomForKey,
};
